module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zx_nor.ea3e1980.png";